import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { BulkAction } from 'src/app/shared/interfaces'

import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core'
import { DataTable } from '@pascalhonegger/ng-datatable'

import { OperationInternalEvent } from '../operation-internal-event'
import { InternalEventTypes } from '../internal-event-types'
import { Product } from 'src/app/features/product/product'
import { Subscription } from 'src/app/features/subscription/subscription'
import { Course } from 'src/app/features/course/course'
import { Dictionary } from '@ngrx/entity'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { productSelectors } from 'src/app/features/product/product.selectors'
import { Observable } from 'rxjs'
import { subscriptionSelectors } from 'src/app/features/subscription/subscription.selectors'
import { courseSelectors } from 'src/app/features/course/course.selectors'
import { InternalEvent } from 'src/app/features/internal-event/internal-event'
import { internalEventSelectors } from 'src/app/features/internal-event/internal-event.selectors'
import { internalEventActions } from 'src/app/features/internal-event/internal-event.actions'
import { Survey } from 'src/app/features/survey/survey'
import { surveySelectors } from 'src/app/features/survey/survey.selectors'
import { getEnumAsArray } from 'src/app/shared/until'

@Component({
  selector: 'operation-internal-event-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class OperationInternalEventTableComponent implements OnInit {
  @Input() tableData: OperationInternalEvent[]
  @Input() bulkActions: BulkAction[] = [BulkAction.DELETE]
  @Output() onBulkAction = new EventEmitter<any>()
  @Output() onClickRow = new EventEmitter<any>()

  @ViewChild('dataTable', { static: true }) dataTable: DataTable

  public filterTerm: string = ''
  public allCheckedToggle: boolean = false
  public checkedIds: Map<number, boolean> = new Map()
  public InternalEventTypes = getEnumAsArray(InternalEventTypes)
  public internalEventTypesArray = []

  public surveyEntities$: Observable<Dictionary<Survey>>
  public productEntities$: Observable<Dictionary<Product>>
  public subscriptionEntities$: Observable<Dictionary<Subscription>>
  public courseEntities$: Observable<Dictionary<Course>>
  public internalEventEntities$: Observable<Dictionary<InternalEvent>>
  public accessRights = AccessRights

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    for (let i = 0; i < this.InternalEventTypes?.length; i++) {
      this.internalEventTypesArray[this.InternalEventTypes[i].value] =
        this.InternalEventTypes[i].key
    }

    this.store.dispatch(internalEventActions.fetchMany({}))

    this.internalEventEntities$ = this.store.select(
      internalEventSelectors.selectEntities
    )
    this.productEntities$ = this.store.select(productSelectors.selectEntities)
    this.subscriptionEntities$ = this.store.select(
      subscriptionSelectors.selectEntities
    )
    this.courseEntities$ = this.store.select(courseSelectors.selectEntities)
    this.surveyEntities$ = this.store.select(surveySelectors.selectEntities)
  }

  public onRowClicked(row: OperationInternalEvent) {
    this.onClickRow.emit(row)
  }

  public onCheckRow(targetRow: OperationInternalEvent) {
    this.checkedIds.set(
      targetRow.id,
      !Boolean(this.checkedIds.get(targetRow.id))
    )
  }

  public onToggleAllChecked() {
    this.allCheckedToggle = !this.allCheckedToggle

    this.dataTable.data.forEach((row) =>
      this.checkedIds.set(row.id, this.allCheckedToggle)
    )
  }

  public onClickBulkAction(bulkOption: string) {
    const rows: Location[] = this.dataTable.data.filter((x) =>
      this.checkedIds.get(x.id)
    )

    if (rows.length > 0) {
      this.onBulkAction.emit({ action: bulkOption, items: rows })
    }
  }
}
